export const getAppFooterText = () => {
    const currentYear = new Date().getFullYear();

    return `© ${currentYear} StepForma. Todos os direitos reservados.`;
};
